/* eslint-disable no-unused-vars */
import { Select } from "antd";
import { authActions, selectAuth } from "Features/auth";
import { errorActions, selectError } from "Features/error";
import React, { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, ErrorFallback, Input } from "Shared/ui";
import SelectLanguage from "Widgets/lang_select";
import { SnAuth } from "Widgets/sn_auth";

import "../../auth.scss";

export const LoginPage = () => {
	const dispatch = useDispatch();
	const fetchAuth = useSelector(selectAuth.fetch);
	const errorPage = useSelector(selectError.page);
	const errorMessage = useSelector(selectError.message);
	const [userData, setUserData] = useState({ username: "", password: "" });

	function onSubmit() {
		dispatch(authActions.login(userData));
	}

	function onChangeUserData(key, value) {
		setUserData({ ...userData, [key]: value });
		if (errorMessage || errorPage) {
			dispatch(errorActions.drop());
		}
	}

	const onChangeUsername = (value) => onChangeUserData("username", value);
	const onChangePassword = (value) => onChangeUserData("password", value);

	return (
		<ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
			<div className="auth">
				<div className="auth__container auth__container_w500">
					<div className="auth__block-container">{/* <SelectLanguage /> */}</div>
					<div className="auth__line mb-30" />
					<div className="auth__block mb-30">
						<div className="auth__block-text mb-10">
							<span className="auth__block-text_big">Sign In</span>
						</div>
						<div className="auth__block-container">
							<div className="auth__block-text auth__block-text_small ">New user?</div>
							<Link to={"/auth/register"}>Create new account</Link>
						</div>
					</div>
					<div className="auth__block-container mb-30">
						<SnAuth />
					</div>

					<div className="auth__block-container mb-20">
						<div className="auth__line" />
						<div className="auth__block-text auth__block-text_middle mr-10 ml-10">Or</div>
						<div className="auth__line" />
					</div>
					<div className="auth__block-text auth__block-text_middle mb-20">Sign up with email / login</div>
					<Input
						placeholder="Email / login"
						id="login"
						type={"text"}
						className="mb-17"
						outValue={userData.username}
						setOutValue={onChangeUsername}
					/>
					<Input
						placeholder="Password"
						id="password"
						type={"password"}
						className="mb-20"
						errorMessage={errorPage === "login" && ["Ivalid login or password"]}
						outValue={userData.password}
						setOutValue={onChangePassword}
					/>

					<Button text="Continue" onClick={onSubmit} className={"mb-5"} isLoading={fetchAuth} />
					<Link to={"/auth/recover"}>Forgot password?</Link>
				</div>
			</div>
		</ErrorBoundary>
	);
};
